module.exports = __webpack_public_path__ + "img/Imagen_Bloque_1.159a73e1.png";